export { BottomCurve, BottomCurveContainer } from './bottom-curve';
export type {
  BottomCurveProps,
  BottomCurveContainerProps,
} from './bottom-curve';
